<template>
   <div class="whatcan" :class="langType ? 'cn' : ''">
      <HeaderDescription
         :header="config.header"
         :description="descriptionJoiner(config.shortDescription)"
      />
      <div v-if="langType" class="section-info" v-html="markedRender(config.longDescription)" />

      <show-at :breakpoints="breakpoints" breakpoint="small">
         <div id="whyaccordion" class="accordion  mt-4 ml-sm-2 mr-sm-2">
            <div v-for="(item, index) in config.body" :key="index" class="card card-transparent">
               <div :id="'heading' + index" class="card-header p-0 mb-1">
                  <h5 class="mb-0">
                     <button
                        class="btn btn-link  bg-white shadow border d-flex justify-content-center align-items-center"
                        :class="{ collapsed: index !== 0 }"
                        type="button"
                        data-toggle="collapse"
                        :data-target="'#collapse' + index"
                        aria-expanded="true"
                        :aria-controls="'#collapse' + index"
                     >
                        <i class="icon" :class="item.icon" />
                        <span>{{ item.header }} </span>
                        <i class="fc_indicator_right" />
                     </button>
                  </h5>
               </div>

               <div
                  :id="'collapse' + index"
                  class="mb-2"
                  :class="['collapse collapse-box ', index === 0 && 'show']"
                  :aria-labelledby="'heading' + index"
                  data-parent="#whyaccordion"
               >
                  <div class="card-body">
                     <div v-if="item.customBody[0].description" class="ml-lg-13">
                        <img
                           v-if="item.customBody[0] && item.customBody[0].vectorSource"
                           v-lazy-image
                           src="/public/images/rect.svg"
                           :data-src="item.customBody[0].vectorSource.file.url"
                           class="mb-1"
                        />
                        <p>{{ item.customBody[0].description }}</p>
                     </div>

                     <div v-if="item.ctas" class="ml-lg-10 mt-3">
                        <a
                           :href="item.ctas[0].link"
                           class="btn btn-link text-uppercase"
                           @click.prevent="go(item.ctas[0].link)"
                           >{{ item.ctas[0].header }}
                           <i class="fc_keyboard_arrow_right" />
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </show-at>

      <hide-at :breakpoints="breakpoints" breakpoint="small">
         <div class="card card-transparent mt-4 ml-2 mr-2 ">
            <div class="tabs row">
               <div class="col-auto w-30">
                  <ul class="nav nav-pills" :class="!langType ? ' flex-column' : ''">
                     <li v-for="(item, index) in config.body" :key="index" class="nav-item">
                        <a
                           href="#"
                           class="nav-link primary-grad btn-block d-flex justify-content-between align-items-center"
                           :class="[{ active: index === selectedIndex }]"
                           @click.prevent="selectedTab(index)"
                        >
                           <i class="icon" :class="item.icon" />
                           <span v-text="item.header" />
                           <i class="fc_indicator_right" />
                        </a>
                     </li>
                  </ul>
               </div>

               <div class="tab-content col">
                  <div
                     v-for="(item, index) in config.body"
                     :key="index"
                     :class="[{ active: index === selectedIndex }]"
                     class="tab-pane"
                  >
                     <div v-if="item.customBody[0].description" class="ml-lg-3">
                        <img
                           v-if="item.customBody[0].vectorSource.file.url"
                           v-lazy-image
                           src="/public/images/rect.svg"
                           :data-src="item.customBody[0].vectorSource.file.url"
                           class="mb-1"
                        />
                        <p v-text="item.customBody[0].description" />
                     </div>

                     <div v-if="item.ctas" class="ml-lg-3 mt-3">
                        <a
                           :href="item.ctas[0].link"
                           class="btn btn-link text-uppercase"
                           @click.prevent="go(item.ctas[0].link)"
                           >{{ item.ctas[0].header }}
                           <i class="fc_keyboard_arrow_right" />
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </hide-at>
   </div>
</template>

<script>
import { showAt, hideAt } from 'vue-breakpoints';
import HeaderDescription from '../core/HeaderDescription.vue';

export default {
   name: 'WhatCan',
   components: {
      HeaderDescription,
      showAt,
      hideAt,
   },
   props: {
      config: {
         type: Object,
         default: () => {},
      },
      langType: {
         type: Object,
         default: () => {},
      },
   },
   data() {
      return {
         breakpoints: {
            small: 800,
         },
         isAccordianRendered: false,
         selectedIndex: 0,
      };
   },
   computed: {},
   watch: {
      $mq(val) {
         this.$nextTick(() => {
            if ((val === 'md' || val === 'sm' || val === 'xs') && !this.isAccordianRendered) {
               setTimeout(() => {
                  this.isAccordianRendered = true;
                  this.initAccordian();
               }, 100);
            }
         });
      },
   },
   mounted() {
      const val = this.$mq;
      if (val === 'md' || val === 'sm' || val === 'xs') {
         this.$nextTick(() => {
            this.isAccordianRendered = true;
            this.initAccordian();
         });
      }
   },

   methods: {
      go(link) {
         window.open(link, '_blank');
      },
      initAccordian() {
         this.accordian('whyaccordion', {
            duration: 600,
         });
      },
      accordian: (id, config) => {
         const parentElm = document.getElementById(id);
         let visibleItem = null;

         if (!parentElm) return;

         const easing = config && config.easing;
         const duration = (config && config.duration) || 500;

         if (parentElm && parentElm.querySelectorAll('.show') === 0) {
            parentElm.querySelectorAll('.collapse')[0].classList.add('show');
         } else {
            [visibleItem] = parentElm.querySelectorAll('.show');
         }

         parentElm.querySelectorAll('[data-toggle="collapse"]').forEach(item => {
            item.addEventListener('click', e => {
               e.preventDefault();

               let _id = item.getAttribute('data-target');
               _id[0] !== '#' && (_id = `#${_id}`);
               const currentItem = parentElm.querySelector(_id);

               currentItem.classList.add('show');
               const currentHeight = currentItem.getBoundingClientRect().height;

               const cb = val => {
                  currentItem.style.height = `${val}px`;
               };
               // const cbl = val => {
               //    visibleItem.style.height = `${val}px`;
               // };

               if (visibleItem === currentItem) {
                  if (visibleItem.classList.value.indexOf('show') >= 0) {
                     currentItem.classList.remove('show');
                  } else {
                     currentItem.classList.add('show');
                  }
                  return;
               }

               currentItem.style.height = 0;

               fusionDesign.animate(0, currentHeight, duration, cb, easing);
               // currentHeight = visibleItem.getBoundingClientRect().height;
               // fusionDesign.animate(currentHeight, 0, duration, cbl, easing);

               // setTimeout(() => {
               //    // visibleItem.style.height = `${currentHeight}px`;
               //    visibleItem.classList.remove('show');
               //    visibleItem = currentItem;
               // }, duration + 1000);
               visibleItem.classList.remove('show');
               visibleItem = currentItem;
            });
         });
      },

      selectedTab(index) {
         this.selectedIndex = index;
      },
   },
};
</script>
<style lang="scss" scoped>
.card-transparent {
   background-color: transparent;
}

.media {
   .icon {
      width: 130px;
      height: 105px;
      display: block;
      // background-color: #ccc;
      margin-top: -23px;
   }
   .media-body {
      padding: 0px 5px 5px 0;
      @media (min-width: 567px) {
         padding: 0px 20px 20px 0;
      }
   }
}

.tabs ::v-deep .nav-pills {
   .nav-item {
      margin-bottom: 1rem;
      // display: block;
      max-width: 30rem;
      .nav-link {
         padding: 0.8rem 1.5rem;
         color: #686980;
         i {
            &.icon {
               background: #fff;
               box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
               border-radius: 50%;
            }
            &.fc_indicator_right {
               color: #fff;
               &:before {
                  color: #fff;
               }
            }
            &:before {
               color: #686980;
            }
         }
         &:hover {
            color: darken(#686980, 15%);
         }
         &.active {
            color: #fff;
            background: transparent linear-gradient(270deg, #5b72de 0%, #745ff9 100%);
            font-family: basefontSemiBold, Helvetica Neue, Arial, sans-serif;
            i {
               &.fc_indicator_right {
                  visibility: visible;
                  color: #fff;
               }

               &.icon {
                  color: #4c3498;
                  &:before {
                     background: -webkit-gradient(
                        linear,
                        0% 0%,
                        0% 100%,
                        from(#4c3498),
                        to(#88b7fd)
                     );
                     background: -webkit-linear-gradient(right, #88b7fd, #4c3498);
                     background: -moz-linear-gradient(right, #88b7fd, #4c3498);
                     background: -ms-linear-gradient(right, #88b7fd, #4c3498);
                     background: -o-linear-gradient(right, #88b7fd, #4c3498);
                     -webkit-background-clip: text;
                     -webkit-text-fill-color: transparent;
                  }
               }
            }
         }

         span {
            display: block;
            text-align: left;
            width: 100%;
         }

         i {
            font-size: 1.6rem;
            vertical-align: middle;
            margin-top: 0;
            margin-right: 15px;
            &.icon {
               padding: 10px;
            }

            &.fc_indicator_right {
               visibility: hidden;
               font-size: 0.8rem;
               margin: 5px 0 0 8px;
            }
         }
      }
   }
}

.accordion {
   .card {
      .card-body {
         padding: 10px 0;
      }
   }
   .btn-link {
      text-decoration: none;
      padding: 1.5rem;
      color: #686980;
      white-space: pre-wrap;
      width: 100%;
      text-transform: initial;
      @media (min-width: 567px) {
         white-space: normal;
      }
      span,
      i {
         display: block;
      }
      i {
         &.icon {
            background: #fff;
            box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
            border-radius: 50%;
            float: left;
         }
         &.fc_indicator_right {
            color: #686980;
            float: right;
            transform: rotate(90deg);
            transition: all ease 0.5s;
            &:before {
               color: #686980;
            }
         }
         &:before {
            color: #686980;
         }
      }
      &.collapsed {
         i {
            &.fc_indicator_right {
               transform: rotate(0deg);
               transition: all ease 0.5s;
            }
            &.icon {
               color: #686980;
               &:before {
                  color: #686980;
                  background: transparent;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: #686980;
               }
            }
         }
      }

      i {
         &.icon {
            color: #4c3498;
            &:before {
               background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#4c3498), to(#88b7fd));
               background: -webkit-linear-gradient(right, #88b7fd, #4c3498);
               background: -moz-linear-gradient(right, #88b7fd, #4c3498);
               background: -ms-linear-gradient(right, #88b7fd, #4c3498);
               background: -o-linear-gradient(right, #88b7fd, #4c3498);
               -webkit-background-clip: text;
               -webkit-text-fill-color: transparent;
            }
         }
      }
      &:hover {
         color: darken(#686980, 15%);
      }

      span {
         display: block;
         text-align: left;
         width: 100%;
      }

      i {
         font-size: 1.6rem;
         vertical-align: middle;
         margin-top: 0;
         margin-right: 15px;
         &.icon {
            padding: 10px;
         }

         &.fc_indicator_right {
            font-size: 0.8rem;
            margin: 5px 0 0 8px;
         }
      }
   }
}

.collapse-box {
   min-height: 50rem;
}

.accordion ::v-deep,
.tabs ::v-deep {
   img {
      width: 100%;
      height: auto;
   }
}

.collapse,
.tab-pane {
   margin-bottom: 0rem;

   .btn-link {
      color: #6957da;
      padding: 0;
      &:hover {
         color: darken(#6957da, 10%);
      }
      i {
         display: inline-block;
         font-size: 2rem;
         margin-top: -2px;
         &:before {
            color: #6957da;
         }
      }
   }
}
.collapse {
   .btn-link {
      white-space: nowrap;
   }
}

.tab-pane {
   .btn-link {
      i {
         vertical-align: middle;
      }
   }

   .list-unstyled {
      li:last-child {
         .media-body {
            p:last-child.mb-3 {
               margin-bottom: 0 !important;
            }
         }
      }
   }
}

.cn {
   .section-info {
      max-width: 85%;
      margin: 2rem auto;
      text-align: center;
   }
   .tabs {
      .col-auto {
         width: 100%;
      }
      .nav-pills {
         border-radius: 4px;
         box-shadow: 0 8px 10px 0 rgba(105, 87, 218, 0.06);
         overflow: hidden;
         .nav-item {
            margin-bottom: 0;
            flex: 1 1 auto !important;
            max-width: initial;
            .nav-link,
            .nav-link.active {
               border-radius: 0;
               padding: 1.5rem;
            }

            .fc_indicator_right {
               display: none;
            }
         }
      }
      .tab-pane {
         &:after {
            content: '';
            width: 100%;
            height: 0;
            display: block;
            clear: both;
         }
         .ml-lg-3 {
            display: flex;
            img {
               order: 1;
            }
            p {
               max-width: 600px;
               align-self: center !important;
               border-right: 2px solid #ccc;
               padding-right: 5rem;
               margin-right: 5rem;
            }
         }
      }
   }
}
</style>
